import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../../firebase";
import type { FactoringEntry } from "components/factoringModel";

interface Request {
  userId: string;
  factoringId: string;
  entries: FactoringEntry[];
}

interface Response {
  success: boolean;
  message: string;
}

interface Props extends Request {
}

export const updateFactoringEntryDetail = async (data: Props) => {
  const functions = getFirebaseFunctions();

  const updateFactoringEntryDetailFunction = httpsCallable<Request, Response, object>(
    functions,
    "admin_updateFactoringEntryDetail",
  );

  try {
    const res = await updateFactoringEntryDetailFunction(data);
    return res.data;
  } catch (error) {
    console.error("Failed to update factoring entry detail:", error);
    throw error;
  }
};
